module.exports = __webpack_public_path__ + "static/media/hsy_v1.d212801a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/hsy_v1.png
// module id = 324
// module chunks = 0